import React from 'react';
import type { VoiceAgentOption } from '../../client';
import Modal from '../Modal';

interface VoiceAgentPickerModalProps {
  isOpen: boolean;
  agents: VoiceAgentOption[];
  currentAgentId?: number;
  busy?: boolean;
  status?: string | null;
  onClose: () => void;
  onSelect: (agentId: number) => void;
}

const modeLabel = (mode: VoiceAgentOption['mode']): string =>
  mode === 'push_to_talk' ? 'Push to talk' : 'Realtime';

const VoiceAgentPickerModal: React.FC<VoiceAgentPickerModalProps> = ({
  isOpen,
  agents,
  currentAgentId,
  busy = false,
  status = null,
  onClose,
  onSelect,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Choose a voice agent"
    maxWidth="520px"
    isBusy={busy}>
    <div className="voice-agent-picker">
      <div className="voice-agent-picker-list">
        {agents.map((agent) => (
          <button
            type="button"
            key={agent.agentId}
            disabled={busy}
            className={`voice-agent-picker-row${
              currentAgentId === agent.agentId
                ? ' voice-agent-picker-row-current'
                : ''
            }`}
            aria-current={currentAgentId === agent.agentId ? 'true' : undefined}
            onClick={() => onSelect(agent.agentId)}>
            <strong>{agent.agentName}</strong>
            <span className="voice-agent-picker-mode">
              {modeLabel(agent.mode)}
            </span>
          </button>
        ))}
        {agents.length === 0 && !status && (
          <p className="voice-agent-picker-status">
            No voice agents are currently available.
          </p>
        )}
      </div>
      {status && (
        <p className="voice-agent-picker-status" role="status">
          {status}
        </p>
      )}
    </div>
  </Modal>
);

export default VoiceAgentPickerModal;
